import { Dialog } from "primereact/dialog";
import { useEffect, useRef, useState } from "react";
import { IRevenueRepFilter } from "../Filter";
import { Fetch } from "../../../../shared/Fetch";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { safeFormatDate } from "../../../../models/DateFormatMapper";
import { ILogin } from "../../../../models/Login";

interface IProps {
    open: boolean,
    hideDialog: () => void,
    user_Employee_ID: string,
    revenueFilter: IRevenueRepFilter,
    toast: any,
}

interface IProjectedRevenue {
    fromDate?: Date,
    toDate?: Date,
    invoiceAmount?: number,
    receivedAmount?: number,
    paymentStatus?: string,
    payment_Date?: Date,
    dueDate?: Date,
}

export const ProjectRevenueDetails = (props: IProps) => {
    const [loading, setLoading] = useState(false);
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<IProjectedRevenue>, loading: boolean });

    const dt = useRef<any>(null);

    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    const DateFormat = loginObj.date_Format;

    const header = () => <p>Project Revenue Details</p>;

    const onHide = () => {
        setLoading(false);
        props.hideDialog();
    };

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const newFilter = {
            fromDate: props.revenueFilter.fromDate,
            toDate: props.revenueFilter.toDate,
            user_Employee_ID: props.user_Employee_ID
        };

        const response = await Fetch("Report_Revenue/getProjectRevenueDetails", "GET", null, `filter=${JSON.stringify(newFilter)}`, props.toast);
        if (response) {
            const data: Array<any> = await response.json();
            setTableData({ tableData: data, loading: false });
        }
    }

    useEffect(() => {
        if (props.open) {
            loadTableData();
        }
    }, [props.open]);

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header={header} modal className="p-fluid" onHide={onHide}>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                ref={dt} size="small" showGridlines stripedRows scrollable scrollHeight="70vh"
                value={tableData.tableData}
                loading={tableData.loading}
            >
                <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} footer={() => {
                    return <b>TOTAL</b>;
                }} />
                <Column field="fromDate" header="From Date" body={(rowData: any) => safeFormatDate(rowData.fromDate, 'dd/MM/yyyy', DateFormat, true)} />
                <Column field="toDate" header="To Date" body={(rowData: any) => safeFormatDate(rowData.toDate, 'dd/MM/yyyy', DateFormat, true)} />
                <Column field="invoiceAmount" header="Invoice Amount" body={(rowData: any) => <span>₹ {parseInt(`${rowData.invoiceAmount}`)}</span>} footer={() => {
                    const AllReq = tableData.tableData.reduce((sum, item) => sum + parseInt(`${(item.invoiceAmount || 0)}`), 0);
                    return <b>₹ {AllReq}</b>;
                }} />
                <Column field="receivedAmount" header="Received Amount" body={(rowData: any) => <span>₹ {parseInt(`${rowData.receivedAmount}`)}</span>} footer={() => {
                    const AllReq = tableData.tableData.reduce((sum, item) => sum + parseInt(`${(item.receivedAmount || 0)}`), 0);
                    return <b>₹ {AllReq}</b>;
                }} />
                <Column field="" header="Projected Amount"
                    body={(item: IProjectedRevenue) => <p>₹ {parseInt(`${((item.receivedAmount || 0) < (item.invoiceAmount || 0) ? ((item.invoiceAmount || 0) - (item.receivedAmount || 0)) : ((item.receivedAmount || 0) - (item.invoiceAmount || 0)))}`)}</p>}
                    footer={() => {
                        const AllReq = tableData.tableData.reduce((sum, item) => sum + parseInt(`${((item.receivedAmount || 0) < (item.invoiceAmount || 0) ? ((item.invoiceAmount || 0) - (item.receivedAmount || 0)) : ((item.receivedAmount || 0) - (item.invoiceAmount || 0)))}`), 0);
                        return <b>₹ {AllReq}</b>;
                    }} />
                <Column field="paymentStatus" header="Payment Status" />
                <Column field="payment_Date" header="Payment Date" body={(rowData: any) => safeFormatDate(rowData.payment_Date, 'dd/MM/yyyy', DateFormat, true)} />
                <Column field="dueDate" header="Due Date" body={(rowData: any) => safeFormatDate(rowData.dueDate, 'dd/MM/yyyy', DateFormat, true)} />
            </DataTable>
        </Dialog>
    );
}